import ProformaCapTableForm from './ProformaCapTableForm';

export default ProformaCapTableForm;
